export type HttpMonitorTab = 'incidents' | 'logs';

export const HTTP_MONITOR_TABS: HttpMonitorTab[] = ['incidents', 'logs'];

export const DEFAULT_HTTP_MONITOR_TAB: HttpMonitorTab = 'incidents';

export const shouldShowHttpMonitorDetailsHeader = (breakpoint: string): boolean =>
    breakpoint !== 'large' && breakpoint !== 'medium';

export const getHttpMonitorChartHeight = (breakpoint: string): number =>
    breakpoint !== 'mini' ? 300 : 200;
